import { useMemo } from "react";
import { generateHTML } from "@tiptap/react";
import DOMPurify from "dompurify";
import { documentExtensions } from "@/lib/document-extensions";

/**
 * Renderuje tiptap JSON dokumenta. Odvojen od BlogRenderer-a jer dokumenti
 * imaju svoju šemu (bez slika i videa, sa placeholder atomom) — renderovanje
 * kroz blog ekstenzije bi tiho ispustilo čvorove koje ta šema ne poznaje.
 */
export function DocumentRenderer({
  content,
  className,
}: {
  content: string | object;
  className?: string;
}) {
  const html = useMemo(() => {
    try {
      const json = typeof content === "string" ? JSON.parse(content) : content;
      return DOMPurify.sanitize(generateHTML(json, documentExtensions), {
        FORBID_ATTR: ["onerror", "onload", "onclick"],
        ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
      });
    } catch {
      return "";
    }
  }, [content]);

  return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}
